import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationVI from './locales/vi.json';
import translationEN from './locales/en.json';

// Translation resources
const resources = {
  vi: {
    translation: translationVI
  },
  en: {
    translation: translationEN
  }
};

// Get saved language from localStorage or default to Vietnamese
const savedLanguage = localStorage.getItem('language') || 'vi';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'vi',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
